import React from "react";
import {LuInfo, LuX} from "react-icons/lu";
import {Dialog, Heading, Modal} from "react-aria-components";
import Notification from "../../../components/Notification/Notification.js";

export function DatabaseHostingInfoButton() {
    let [showModal, setShowModal] = React.useState(false);

    function toggleModal() {
        setShowModal(!showModal);
    }

    return <div className="hosting-info-button">
        <LuInfo onClick={toggleModal}/>
        <Modal isOpen={showModal} isDismissable onOpenChange={toggleModal}>
            <Dialog aria-label="Hosting Mode Info" className="hosting-info-modal">
                <Heading className="title">Hosting Modes</Heading>
                <p className="description">
                    <strong>Cloud-Hosted</strong>: This mode allows you to use the proxy service without hosting it
                    yourself. The proxy is hosted on our servers and you can connect to it using a database URI. This is
                    the easiest way to get started with the proxy.
                    <Notification>Use this for evaluation purposes</Notification>
                    <br/>
                    <strong>Self-Hosted</strong>: This mode allows you to host the proxy on your own infrastructure. You
                    can run the proxy on your own servers and connect to it using a database URI. This is recommended
                    for production use cases.
                    <Notification>Use this for security conscious purposes</Notification>
                </p>
                <div className="close"><LuX onClick={toggleModal}/></div>
            </Dialog>
        </Modal>
    </div>
}